import {Injectable} from '@angular/core';
import {Subject, Observable, BehaviorSubject} from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { Meta } from '../_models/meta';


@Injectable()
export class GLMLanguageService {
    private subject = new BehaviorSubject<any>({activeLang: null});
    language$ = this.subject.asObservable().pipe(shareReplay(1));
    activeLang = null;

    constructor() {}

    setLanguage(idioma){
        this.activeLang = {activeLang: idioma};
        this.subject.next({activeLang: idioma});
    }

    getCurrLanguage() {
        return this.activeLang;
    }

    getLanguageObservable(): Observable<any> {
        return this.language$;
    }

    setIdiomaMetas(metas: Meta[], idioma: string) {
      metas.forEach(meta => {
        const currDesc = meta['txt' + idioma.toUpperCase()];
        if (currDesc !== '') {
          meta.txtIdioma = currDesc;
        }
        meta.criterios.forEach(criterio => {
          const idiomaIndex = criterio.idiomas.findIndex(item => item.idioma === idioma);
          if (idiomaIndex > -1) {
            criterio.nombre = criterio.idiomas[idiomaIndex].nombre;
          }
          criterio.niveles.forEach(nivel => {
            nivel.criterios.forEach(crit => {
              const idiomaIndex = crit.idiomas.findIndex(item => item.idioma === idioma);
              if (idiomaIndex > -1) {
                crit.nombre = crit.idiomas[idiomaIndex].nombre;
              }
            });
          });
        });
      });
      return metas;
    }
}
